import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";

export default function ZipHero({ defaultZip = "" }) {
    const [zip, setZip] = useState(defaultZip);
    const navigate = useNavigate();

    const onSubmit = (e) => {
        e.preventDefault();
        const trimmed = zip.trim();
        if (!/^\d{5}$/.test(trimmed)) {
            return navigate(`/get-started?zip=`);
        }
        navigate(`/get-started?zip=${trimmed}`);
    };

    return (
        <form
            onSubmit={onSubmit}
            data-testid="hero-zip-form"
            className="mt-8 flex flex-col sm:flex-row gap-3 items-stretch max-w-lg"
        >
            <div className="relative flex-1">
                <MapPin className="w-5 h-5 text-emerald-300 absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none" />
                <input
                    data-testid="hero-zip-input"
                    inputMode="numeric"
                    pattern="\d{5}"
                    maxLength={5}
                    value={zip}
                    onChange={(e) => setZip(e.target.value.replace(/[^0-9]/g, ""))}
                    placeholder="Enter your ZIP code"
                    className="input-dark !pl-12"
                    aria-label="ZIP code"
                />
            </div>
            <button type="submit" className="btn-primary" data-testid="hero-check-options-btn">
                Check my options <ArrowRight className="w-4 h-4" />
            </button>
        </form>
    );
}
